import React from 'react';
import { Box, Container, Typography, List, ListItem, ListItemText, Divider } from '@mui/material';

const sections = [
  {
    title: '1. Who we are',
    body: [
      'MRM Lettings Property & Management Ltd is a letting and property management agency operating from a single office at 142 Victoria Road, Middlesbrough, TS1 3HU.',
      'We are members of professional bodies and client money protection schemes where applicable. Contact details: info@mrmlettings.co.uk, 01642 243378.',
    ],
  },
  {
    title: '2. Using this website',
    body: [
      'By using this site you confirm you are over 18 and agree to use it for lawful purposes only.',
      'Content is provided for general guidance and marketing only. It is not financial, legal or professional advice.',
      'We may update or withdraw content without notice and do not guarantee uninterrupted availability.',
    ],
  },
  {
    title: '3. Property details & valuations',
    body: [
      'Property particulars, floor areas, photographs and availability are marketing materials and may change without notice.',
      'Any indicative valuations or yield calculations are estimates only and subject to inspection, survey, referencing and contract.',
    ],
  },
  {
    title: '4. Our services',
    body: [
      'For landlords we provide tenant-find and fully managed services. Terms of business will be agreed in a separate agency agreement.',
      'For tenants we arrange viewings, reference checks and tenancy agreements on behalf of the landlord.',
      'All offers are subject to satisfactory references, right-to-rent checks and a signed tenancy agreement.',
    ],
  },
  {
    title: '5. Fees & charges',
    body: [
      'Landlord fees and management charges are confirmed in your agency agreement before marketing begins.',
      'Permitted tenant payments include rent, refundable tenancy deposit, holding deposit (max one week’s rent), default fees for lost keys/replacement locks, late payment interest (as permitted by law) and agreed variation/early termination charges.',
    ],
  },
  {
    title: '6. Your responsibilities',
    body: [
      'You must ensure information you provide is accurate and not misleading.',
      'You are responsible for securing your own independent advice (legal, financial, survey, tax) before committing to a transaction.',
      'You must comply with applicable laws, including anti-money laundering and right-to-rent requirements.',
    ],
  },
  {
    title: '7. Liability',
    body: [
      'We exclude liability for losses arising from use of this site, except where such exclusion is prohibited by law.',
      'We do not accept responsibility for third-party websites or services linked from this site.',
      'Nothing in these terms limits liability for death or personal injury caused by our negligence or for fraud.',
    ],
  },
  {
    title: '8. Complaints',
    body: [
      'If you have a complaint, please contact info@mrmlettings.co.uk or 01642 243378 in the first instance. We follow an internal complaints procedure and will provide details of any redress scheme membership on request.',
    ],
  },
  {
    title: '9. Governing law',
    body: [
      'These terms are governed by the laws of England and Wales. Any disputes are subject to the exclusive jurisdiction of the courts of England and Wales.',
    ],
  },
];

export default function TermsPage() {
  return (
    <Box component="main" sx={{ bgcolor: 'background.default', py: { xs: 6, md: 10 } }}>
      <Container maxWidth="md">
        <Typography variant="overline" color="text.secondary">
          Legal
        </Typography>
        <Typography variant="h3" fontWeight={800} gutterBottom>
          Terms &amp; Conditions
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Please read these terms before using our website or engaging our services. They describe how
          you may use our site, the basis on which we provide information, and key responsibilities for
          landlords and tenants. They sit alongside any signed agency or tenancy agreement.
        </Typography>

        {sections.map((section, idx) => (
          <Box key={section.title} sx={{ mb: 3.5 }}>
            <Typography variant="h6" fontWeight={700} gutterBottom>
              {section.title}
            </Typography>
            <List dense disablePadding>
              {section.body.map((item, i) => (
                <ListItem key={i} sx={{ alignItems: 'flex-start', px: 0 }}>
                  <ListItemText
                    primary={
                      <Typography variant="body1" color="text.primary">
                        {item}
                      </Typography>
                    }
                  />
                </ListItem>
              ))}
            </List>
            {idx < sections.length - 1 && <Divider sx={{ mt: 2, mb: 2.5 }} />}
          </Box>
        ))}
      </Container>
    </Box>
  );
}
